var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(card,i){return _c('div',{key:i},[_c('h2',{staticClass:"text-left underline-title"},[_vm._v(" "+_vm._s(card.titulo)+" ")]),_c('div',{staticClass:"bar mb-1"}),_c('p',{staticClass:"body-text pt-4 mt-2"},[_vm._v(" "+_vm._s(card.texto)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }